import React from 'react';
import { Container } from 'react-bootstrap';
import './cartaGeneral.css';
import restoMenuConfig from './restoMenuConfig';
import Accordion from '../components/accordion/Accordion';

const Carta = () => {
  return (
    <div>
      <Container style={{ paddingTop: '40px' }}>
        {restoMenuConfig.map((section) => {
          return (
            <Accordion
              key={section.title}
              title={section.title}
              content={section.component}
              isResto
              section={section}
            />
          );
        })}
      </Container>
    </div>
  );
};

export default Carta;
